
    
    <template>
  <b-container>
    <b-overlay :show="show" rounded="sm">
      <b-card class="shadow-sm p-3 rounded mb-3">
        <b-col align="left" class="mb-3">
          <h5>Listado de Proveedores</h5>
        </b-col>
        <b-table
          :items="items"
          :fields="fields"
          bordered
          striped
          small
          class="text-sm compact-table"
        >
          <template #cell(status)="row">
            <b-badge :variant="statusColorOptions[row.item.status]">{{
              statusOptions[row.item.status]
            }}</b-badge>
          </template>
          <template #cell(actions)="row">
            <b-icon
              class="pointer"
              @click="editItem(row.item)"
              icon="pencil"
            ></b-icon>
            <b-icon
              v-if="row.item.status === 'p'"
              title="Enviar credenciales"
              class="ml-2 pointer text-info"
              @click="sendCredentials(row.item.id, row.item.company_name)"
              icon="envelope"
            />
          </template>
        </b-table>
      </b-card>
    </b-overlay>
    <b-modal id="success-modal" hide-header hide-footer centered>
      <b-container>
        <b-row>
          <b-col class="pt-3 pb-4" align="center">
            <h4>{{ msgModal }}</h4>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col align="center">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="$bvModal.hide('success-modal')"
            >
              Cerrar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      id="confirm-send-modal"
      hide-footer
      v-model="showConfirmModal"
      centered
      hide-header 
    >
      <b-container>
        <b-row>
          <b-col class="pt-3 pb-4" align="center">
            <h5>
              ¿Deseás enviar las credenciales a
              <strong>{{ providerNameToSend }}</strong
              >?
            </h5>
          </b-col>
        </b-row>
        <b-row class="pb-3" align-h="center">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showConfirmModal = false"
            >Cancelar</b-button
          >
          <b-button variant="primary" @click="confirmSendCredentials"
            >Confirmar</b-button
          >
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>
      
<script>
import axios from "../../utils/axios";

export default {
  data() {
    return {
      providerNameToSend: "",
      providerIdToSend: null,
      showConfirmModal: false,

      showModal: false,
      show: false,
      items: [],
      fields: [
        { key: "cuit", label: "CUIT" },
        { key: "company_name", label: "Razón Social" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Teléfono" },
        { key: "status", label: "ESTADO" },
        { key: "actions", label: "Acciones" },
      ],
      msgModal: "",
      statusOptions: {
        p: "pendiente",
        pp: "pend.proveedor",
        pr: "pend.revisión",
        c: "confirmado",
        a: "aprobado",
        r: "rechazado",
      },
      statusColorOptions: {
        p: "info",
        pp: "light",
        pr: "warning",
        c: "success",
        a: "success",
        r: "danger",
      },
    };
  },
  mounted() {
    this.getProviders();
  },
  methods: {
    sendCredentials(providerId, providerName) {
      this.providerIdToSend = providerId;
      this.providerNameToSend = providerName;
      this.showConfirmModal = true;
    },

    getProviders() {
      this.show = true;
      axios
        .get("/providers")
        .then((response) => {
          this.items = response.data;
          this.show = false;
        })
        .catch((error) => {
          console.error("Error al obtener proveedores:", error);
          this.show = false;
        });
    },
    confirmSendCredentials() {
      this.showConfirmModal = false;
      this.show = true;
      axios
        .post("/providers/sendCredentials", {
          provider_id: this.providerIdToSend,
        })
        .then((response) => {
          this.msgModal = response.data.msg;
          this.$bvModal.show("success-modal");
          this.getProviders();
          this.show = false;
        })
        .catch((error) => {
          console.error("Error al enviar credenciales:", error);
          this.show = false;
        });
    },

    editItem(item) {
      /*this.getProvincesAndCities();
      this.showEditModal = true;
      this.editForm = { ...item };*/      
      this.$router.push({
        name: "providers/edit",
        params: {
          id: item.id, // Pasas el objeto completo como prop
        },
      });
    },
  },
};
</script>
<style scoped>
.square-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px; /* Bordes cuadrados */
  font-size: 20px;
}
.label {
  font-size: 9pt !important;
  text-align: left;
  margin-bottom: 1pt !important;
}
</style>